import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import PropTypes from 'prop-types';

const Loading = ({ show, progressRate, hideProgressBar }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="loadingContainer">
      <svg id="loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <rect width="24" height="24" transform="rotate(180 12 12)" opacity="0"></rect>
        <path d="M12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1z" fill="#0065D6"></path>
        <path d="M21 11h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z" fill="#0065D6"></path>
        <path d="M6 12a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1z" fill="#0065D6"></path>
        <path d="M6.22 5a1 1 0 0 0-1.39 1.47l1.44 1.39a1 1 0 0 0 .73.28 1 1 0 0 0 .72-.31 1 1 0 0 0 0-1.41z" fill="#0065D6"></path>
        <path d="M17 8.14a1 1 0 0 0 .69-.28l1.44-1.39A1 1 0 0 0 17.78 5l-1.44 1.42a1 1 0 0 0 0 1.41 1 1 0 0 0 .66.31z" fill="#0065D6"></path>
        <path d="M12 18a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1z" fill="#0065D6"></path>
        <path d="M17.73 16.14a1 1 0 0 0-1.39 1.44L17.78 19a1 1 0 0 0 .69.28 1 1 0 0 0 .72-.3 1 1 0 0 0 0-1.42z" fill="#0065D6"></path>
        <path d="M6.27 16.14l-1.44 1.39a1 1 0 0 0 0 1.42 1 1 0 0 0 .72.3 1 1 0 0 0 .67-.25l1.44-1.39a1 1 0 0 0-1.39-1.44z" fill="#0065D6"></path>
      </svg>
      {!hideProgressBar && (
        <ProgressBar now={progressRate} />
      )}
      <p className="mt-15 bold">
        データを取得しています・・・<br/>
        10~50秒かかる場合がございます。
      </p>
    </div>
  );
};

Loading.propTypes = {
  progressRate: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  hideProgressBar: PropTypes.bool,
};

export default Loading;
